export { default } from './Footer';
export { default as EligibilityClaim } from './EligibilityClaim';
export { default as Disclaimer } from './Disclaimer';
export { default as Footnotes } from './Footnotes';
